import {
  Component,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { CommonService } from 'src/app/services/common/common.service';
import { UrlUtilService } from 'src/app/services/common/url-util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  constructor(private common: CommonService, private urlUtil: UrlUtilService) {}

  //----------------------------  Constant  --------------------------------//

  //----------------------------  Input Output  --------------------------------//
  @Input() menuItems: MenuItem[] = [];
  @Output() menuItemsChange: EventEmitter<MenuItem[]> = new EventEmitter<
    MenuItem[]
  >();

  //----------------------------  Valiable  --------------------------------//
  isMobile = this.common.isMobile();

  //----------------------------  Get Set  --------------------------------//

  ngOnInit() {
    this.menuItems = this.reModelMenu(this.menuItems);
    this.menuItemsChange.emit(this.menuItems);
  }

  reModelMenu(origin: MenuItem[]): any {
    return origin.map((o) => {
      return {
        ...o,
        url: !!o.url
          ? o.url.replace('{baseUrl}', environment.redirectUrl)
          : null,
        items: !!o.items ? this.reModelMenu(o.items) : null,
      };
    });
  }
}
